var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticStyle:{"height":"auto"}},[_c('Head')],1),_c('el-main',[_c('router-view')],1),_c('el-footer',{staticStyle:{"height":"auto"}},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }